import { ReactElement } from 'react';
import { Badge, BadgeProps, Body1Strong } from '@fluentui/react-components';
import { ErrorCircleRegular, QuestionCircleRegular, WarningRegular } from '@fluentui/react-icons';

import { SEVERITY_LABEL } from '../../constants';
import { TReviewSeverity } from '../../types';

// Severity is carried by icon and text as well as color.
const SEVERITY_META: Record<TReviewSeverity, { color: BadgeProps['color']; icon: ReactElement }> = {
  major: { color: 'danger', icon: <ErrorCircleRegular /> },
  minor: { color: 'warning', icon: <WarningRegular /> },
  needsReview: { color: 'informative', icon: <QuestionCircleRegular /> },
};

type TProps = {
  severity: TReviewSeverity;
  size?: BadgeProps['size'];
};

export const SeverityBadge = ({ severity, size = 'extra-large' }: TProps) => {
  const meta = SEVERITY_META[severity] ?? SEVERITY_META.needsReview;
  return (
    <Badge appearance="tint" color={meta.color} size={size} icon={meta.icon}>
      <Body1Strong>{SEVERITY_LABEL[severity] ?? severity}</Body1Strong>
    </Badge>
  );
};
